import React from "react";
// Common Components
import { Button, AddButton, Modal } from "src/Components";
// Local Components
import SettingModal from "./SettingModal";
import AddOrEditModal from "./AddOrEditModal";
import Orderbook from "./Orderbook";
import Tasks from "./Tasks";
import TablesWrapper from "./TablesWrapper";
// Hooks
import { useAppDispatch, useAppSelector } from "src/App/hooks";
// Utilities
import {
  setIsEdit,
  closeModal,
  openAddOrEditModal,
  openSettingModal,
} from "src/Features/AutomaticMarketMaking/automaticMarketMakingSlice";

enum ModalMode {
  Closed,
  Setting,
  AddOrEdit,
}

const Execusion: React.FC = () => {
  // local store
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const dispatch = useAppDispatch();
  const modalMode = useAppSelector(
    (store) => store.automaticMarketMaking.modalMode
  );

  React.useEffect(() => {
    if (refreshFlag) setTimeout(() => setRefreshFlag(false), 1500);
  }, [refreshFlag]);

  const getModalUI = React.useMemo(() => {
    switch (modalMode) {
      case ModalMode.Setting:
        return <SettingModal onClose={() => dispatch(closeModal())} />;

      case ModalMode.AddOrEdit:
        return (
          <AddOrEditModal
            onClose={() => {
              dispatch(closeModal());
              setRefreshFlag(true);
            }}
          />
        );
      default:
        return <></>;
    }
  }, [modalMode]);

  return (
    <div className="w-full h-full">
      {modalMode !== ModalMode.Closed ? (
        <Modal
          title={modalMode === ModalMode.Setting ? "تنظیمات" : "تسک بازارگردانی"}
          UI={getModalUI}
          onClose={() => dispatch(closeModal())}
          modalBoxClassName={
            modalMode === ModalMode.Setting ? "!w-[1500px]" : ""
          }
        />
      ) : (
        <></>
      )}
      <div className="flex flex-row justify-start items-start gap-3 w-full h-auto">
        <Orderbook />
        <div className="flex flex-col justify-start items-start gap-3">
          <Button
            onClick={() => dispatch(openSettingModal())}
            text="تنظیمات"
            variant="contained"
          />
        </div>
      </div>

      <div className="w-full h-max">
        <div className="pb-3 z-10 flex flex-row justify-between items-center">
          <AddButton
            onClick={() => {
              dispatch(openAddOrEditModal());
              dispatch(setIsEdit(false));
            }}
          />
        </div>
        <Tasks {...{ refreshFlag, setRefreshFlag }} />
      </div>
      <div className="w-full h-full flex flex-col justify-start items-start gap-3">
        <TablesWrapper />
      </div>
    </div>
  );
};

export default Execusion;
